export function index(){
    const fv = document.getElementById('fv');
    fv.classList.add('active');
}